import React from 'react';
import styled from 'styled-components';
import Spinner from 'js/components/common/Spinner';

const Container = styled.div`
  min-height: 33.125rem;
  display: grid;
  align-content: center;
  justify-content: center;
`;

export default () => (
  <Container>
    <Spinner />
  </Container>
);
